export enum FollowUpStudyReportPreparationMethod {
	Sabr = 1,
	Manual = 2,
}
